import type { Dayjs } from "dayjs";
import type {
  Notice,
  NoticeAudience,
  NoticeDisplay,
  NoticeSeverity,
} from "./queries/notices";

// Canonical Czech for oznámení (AGENTS.md § Terminologický slovník).

export const NOTICE_DISPLAY_LABELS: Record<NoticeDisplay, string> = {
  banner: "Lišta",
  popup: "Vyskakovací okno",
};

export const NOTICE_SEVERITY_LABELS: Record<NoticeSeverity, string> = {
  info: "Informace",
  warn: "Upozornění",
  err: "Naléhavé",
};

export const NOTICE_AUDIENCE_LABELS: Record<NoticeAudience, string> = {
  public: "Přihlašovací stránka",
  signed_in: "V aplikaci",
  both: "Přihlašovací stránka i aplikace",
};

export type NoticeStatus = "scheduled" | "live" | "ended";

export const NOTICE_STATUS_LABELS: Record<NoticeStatus, string> = {
  scheduled: "Naplánováno",
  live: "Zobrazuje se",
  ended: "Skončilo",
};

export const NOTICE_STATUS_VARIANT: Record<NoticeStatus, "ok" | "info" | "muted"> = {
  scheduled: "info",
  live: "ok",
  ended: "muted",
};

/**
 * Where a notice stands at `now`: the same window the server applies
 * (`notice.Active`), start inclusive, end exclusive. Display only; what
 * a reader sees is decided by the server.
 */
export function noticeStatus(
  n: Pick<Notice, "starts_at" | "ends_at">,
  now: Dayjs,
): NoticeStatus {
  if (n.starts_at && now.isBefore(n.starts_at)) return "scheduled";
  if (n.ends_at && !now.isBefore(n.ends_at)) return "ended";
  return "live";
}
